// extracted by mini-css-extract-plugin
module.exports = {"fullbleed":"image_fullbleed__1_Cf0","custom-img":"image_custom-img__r0kOd","unsetimg":"image_unsetimg___4DA6"};